// TODO: This info for products SHOULD be coming from the backend. Use monorepo/database to get in order.
export interface Product {
  id: string;
  price?: string;
  priceInt?: number;
  name: string;
  isMostPopular?: boolean;
  // If bundle key is present, isBundle === true
  // Each bundle will have Premium cards
  isBundle?: boolean;
  bundle?: {
    quantity?: number;
    discount: number; // 15 = 15%
    singleCardPrice: number;
    singleCardDiscountPrice: string;
  };
  stripePriceId?: string;
}

export const SINGLE_CARD_PRICE = 4.99; // Ensure it remains decimal, as BE is using for computation

export const PRODUCTS: Record<string, Product> = {
  mini: { id: "mini", price: "0", priceInt: 0, name: "Mini Cardoly" },
  unlimited: {
    id: "unlimited",
    priceInt: 49.99,
    name: "Unlimited Cardolies",
    isBundle: true,
  },
  premium: {
    id: "premium",
    name: "Premium Cardoly",
    isMostPopular: true,
  },
};
